import * as React from 'react'
import { AccountDto } from '@halo/dtos/account.dto'
import { Well } from '@pushly/aqe/lib/components'
import { notification, Skeleton } from 'antd'
import { classnames } from '@halo/_utils/classnames'
import CopyToClipboard from 'react-copy-to-clipboard'
import { simpleNotification } from '@halo/_utils/notifications'
import * as randomstring from 'randomstring'

interface IAccountSendIntegrationsWell {
    loading?: boolean
    account: AccountDto
    title?: string
    onAccountUpdated: (account: Partial<AccountDto>) => void
}

interface IASIWState {
    showDrawer: boolean
    drawerKey?: string
}

export class AccountSendIntegrationsWell extends React.Component<IAccountSendIntegrationsWell, IASIWState> {
    public state: IASIWState = {
        showDrawer: false,
    }

    public render() {
        return (
            <Well className="type-3 nested" title="Send Integrations" hideFooter={true}>
                <Skeleton loading={this.props.loading} active={true} title={false}>
                    {!this.props.loading && <>{this.renderVapidWell()}</>}
                </Skeleton>
            </Well>
        )
    }

    protected renderVapidWell() {
        return (
            <Well.Section title="Vapid Configuration">
                <div className={classnames('form-layout-row')}>
                    <div className={classnames('form-layout-row-label')}>Public Key</div>
                    <div className={classnames('form-layout-row-value', 'can-copy')}>
                        <CopyToClipboard
                            onCopy={() => this.handleCopied('public vapid key')}
                            text={this.props.account.vapid_public_key}
                        >
                            <span>{this.props.account.vapid_public_key}</span>
                        </CopyToClipboard>
                    </div>
                </div>

                <div className={classnames('form-layout-row')}>
                    <div className={classnames('form-layout-row-label')}>Private Key</div>
                    <div className={classnames('form-layout-row-value', 'can-copy')}>
                        <CopyToClipboard
                            onCopy={() => this.handleCopied('private vapid key')}
                            text={this.props.account.vapid_private_key}
                        >
                            <span>{this.props.account.vapid_private_key}</span>
                        </CopyToClipboard>
                    </div>
                </div>
            </Well.Section>
        )
    }

    protected handleDrawerOpen = async () => {
        return this.setState({ showDrawer: true, drawerKey: randomstring.generate() })
    }

    protected handleDrawerClose = async () => {
        return this.setState({ showDrawer: false })
    }

    protected handleCopied = (field: string) => {
        notification.destroy()
        simpleNotification('success', `Your ${field} has been copied!`)
    }
}
